import type { IconSvgObject } from './types';

const HandbagIcon: IconSvgObject = [
  ["path", { d: "M5 9H19C20.1046 9 21 9.89543 21 11V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V11C3 9.89543 3.89543 9 5 9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 9V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default HandbagIcon;
